import { createSlice } from '@reduxjs/toolkit';

const initialBreadcrumbState = {
  breadcrumb: [],
};

const breadcrumbSlice = createSlice({
  name: 'breadcrumb',
  initialState: initialBreadcrumbState,
  reducers: {
    updateBreadcrumbData(state, { payload }) {
      state.breadcrumb = payload;
    },
    clearBreadcrumb: () => initialBreadcrumbState,
  },
});

export const { updateBreadcrumbData, clearBreadcrumb } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
